import { queryOptions, skipToken } from '@tanstack/react-query'

import { getReportStatus, listReports } from './requests'

import type { ListReportsParams, ListReportsResponse, Report, ReportStatusResponse } from './types'
import type { UseQueryOptions } from '@tanstack/react-query'

const QUERY_KEY_ROOT = 'yieldbirdWrapperAgent'

export const reportsQueryKey = [QUERY_KEY_ROOT, 'reports'] as const

type ReportsQueryKey = readonly [...typeof reportsQueryKey, ListReportsParams]

type ReportStatusQueryKey = readonly [typeof QUERY_KEY_ROOT, 'status', Report['jobId'] | undefined]

export const reportsQueryOptions = (
  params: ListReportsParams,
): UseQueryOptions<ListReportsResponse, Error, ListReportsResponse, ReportsQueryKey> =>
  queryOptions({
    queryFn: () => listReports(params),
    queryKey: [...reportsQueryKey, params] as const,
    refetchOnWindowFocus: false,
  })

export const reportStatusQueryOptions = (
  jobId: Report['jobId'] | undefined,
): UseQueryOptions<ReportStatusResponse, Error, ReportStatusResponse, ReportStatusQueryKey> =>
  queryOptions({
    queryFn: jobId === undefined ? skipToken : () => getReportStatus(jobId),
    queryKey: [QUERY_KEY_ROOT, 'status', jobId] as const,
    refetchOnWindowFocus: false,
  })
